module.exports = __webpack_public_path__ + "img/bacf0bfae1b633a249aeec14a632c603.png";